/** The codes the server stores on a failed text step, each with its own translated message. */
const RUN_ERROR_CODES = [
  'provider_unavailable',
  'generation_timed_out',
  'input_too_large',
  'request_blocked',
  'generation_failed',
] as const;

export type RunErrorCode = (typeof RUN_ERROR_CODES)[number];

/** A storyboard run fails for the same reasons, and also when it drew no frame at all. */
const STORYBOARD_RUN_ERROR_CODES = [...RUN_ERROR_CODES, 'no_frame_rendered'] as const;

export type StoryboardRunErrorCode = (typeof STORYBOARD_RUN_ERROR_CODES)[number];

const knownCodeOf =
  <Code extends string>(codes: readonly Code[]) =>
  (error: { code: string } | null | undefined): Code | null =>
    codes.find((code) => code === error?.code) ?? null;

/** The code when the server's message has a translation here, so its English text never renders. */
export const runErrorCodeOf = knownCodeOf(RUN_ERROR_CODES);

export const storyboardRunErrorCodeOf = knownCodeOf(STORYBOARD_RUN_ERROR_CODES);
